'use client';
import React from 'react';
import Modal from '../../Modal';
import { Button } from '@osmosis/react-ui/components/Button';
import { Flex } from '@osmosis/react-ui/components/Box';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { useIntl } from 'react-intl';
import { useLanguageContext } from '../../../context/LanguageProvider';
import { getStorePages } from '@osmosis/shared/products';
import { ComposerBlockElement } from '../../../types/composer';
import { usePathname } from 'next/navigation';
import { textGray500 } from '@osmosis/tailwind-ui/styles';
import { useFeatureFlagsContext } from '../../../context/FeatureFlagsContext';

/**
 * Display visitor type modal component.
 */
const VisitorTypeModal: ComposerBlockElement = () => {
  const colors = useColors();
  const intl = useIntl();

  const { storeType, activeLanguage } = useLanguageContext();

  const items = getStorePages(activeLanguage, storeType);
  const featureFlags = useFeatureFlagsContext();
  const isLpnReleaseEnabled = featureFlags.isActive('lpn-release');

  // if flag is off, don't show LPN in the header -- can be removed after release is stable
  if (!isLpnReleaseEnabled) {
    const lpnIndex = items.findIndex((item) => item.key === 'LPN');
    if (lpnIndex !== -1) {
      items.splice(lpnIndex, 1);
    }
  }

  const pathname = usePathname();

  return (
    <Modal
      isVisible={true}
      hide={() => undefined}
      disableHide={true}
      headerContent={intl.formatMessage({
        defaultMessage: 'Show me Osmosis for...',
        id: 'visitor_modal.header',
      })}
      headerClasses={`py-2 font-bold ${textGray500} flex-1 text-center`}
    >
      <Flex
        p={3}
        sx={{ borderTop: `1px solid ${colors.gray5}`, gap: 2 }}
        flexDirection="column"
      >
        {items.map((item) => (
          <Button
            as="a"
            role="button"
            href={`${pathname}/${item.url}`}
            key={item.key}
            variant="outline"
            data-testid={`visitor-type-modal-${item.key}`}
          >
            {item.storeName}
          </Button>
        ))}
      </Flex>
    </Modal>
  );
};

VisitorTypeModal.schema = {
  name: 'visitor-type-modal',
  label: 'Visitor Type Modal',
};

export default VisitorTypeModal;
